import { i18n } from '@lingui/core';
import { getBaseLocale } from './helpers';
import {
  BaseLocales,
  getCatalogMessages,
  getDefaultCatalogs,
  Locales,
  RegionalLocales
} from './i18nLingui';

const localeByPathSegment: Record<string, Locales> = {
  br: BaseLocales.BrazilianPortuguese,
  de: BaseLocales.German,
  'de-ch': RegionalLocales.GermanSwitzerland,
  'de-de': RegionalLocales.GermanGermany,
  es: BaseLocales.Spanish,
  'es-es': RegionalLocales.SpanishSpain,
  'es-mx': RegionalLocales.SpanishMexico,
  fr: BaseLocales.French,
  'fr-ca': RegionalLocales.FrenchCanada,
  'fr-fr': RegionalLocales.FrenchFrance,
  it: BaseLocales.Italian,
  nl: BaseLocales.Dutch,
  ru: BaseLocales.Russian,
  'en-au': RegionalLocales.EnglishAustralia,
  'en-ca': RegionalLocales.EnglishCanada,
  'en-gb': RegionalLocales.EnglishUK,
  'en-in': RegionalLocales.EnglishIndia
};

export const getInitialLocaleFromPathname = (
  pathname: string
): BaseLocales => {
  const pathSegment = pathname.split('/')[1]?.toLowerCase();
  const locale = pathSegment ? localeByPathSegment[pathSegment] : undefined;

  return locale ? getBaseLocale(locale) : BaseLocales.English;
};

export const loadCatalogForLocale = async (locale: BaseLocales) => {
  if (locale === BaseLocales.English) {
    const defaultCatalogs = await getDefaultCatalogs();
    return defaultCatalogs[BaseLocales.English];
  }

  const catalogModule = await import(`./${locale}/messages.js`);
  return getCatalogMessages(catalogModule);
};

export const bootstrapLingui = async (pathname: string) => {
  const locale = getInitialLocaleFromPathname(pathname);
  const messages = await loadCatalogForLocale(locale);

  i18n.load(locale, messages);
  i18n.activate(locale);

  return locale;
};
